
import { faEnvelope, faMoon } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {useState} from 'react'
import styled from 'styled-components'
import theme from '../../themes'
import { Modal } from '../modal/Modal';

const EmailContainer = styled.div`
/* width:40px;
height:40px;
position:fixed;
bottom:100px;
right:30px;
align-items:center;
cursor:pointer;
box-shadow:0px 0px 15px 0px #312f2f;
border-radius:50%;

background-color:${theme.white}; */
position:fixed;
bottom:150px;
left:35px;
color:${theme.primary};


@media screen and (max-width:480px){
    position:fixed;
    bottom:130px;

}
`;

const EmailIcon = styled.a`
width:100%;
height:100%;
border-radius:50%;
align-items:center;

:hover{
    cursor: pointer;
}
`;


export function Email(props){
const [showModal, setShowModal] = useState(false)
const openModal = ()=>{
 setShowModal (prev =>!prev);
};

return <EmailContainer>
    <EmailIcon onClick={openModal}> 
    <a style={{borderRadius:"100%",width:"40px",height:"40px"}} href={"#"}><FontAwesomeIcon className="fa-2x" style={{color:"${theme.primary}"}} icon={faEnvelope}/></a>
     </EmailIcon>
    {/* <Modal showModal = {showModal} setShowModal={setShowModal}/> */}
    </EmailContainer>
}
